import { lazyGetAttachment } from 'owa-attachment-model-store';
import getAttachmentFileType from 'owa-attachment-model-store/lib/utils/getAttachmentFileType';
import { selectMailStoreItemById } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import { getOrCreateSxSStoreData } from 'owa-sxs-store';

const getCustomPropertiesForSigs = function (sxsId: string): { FileType: string; Sender: string } {
    const attachmentId = getOrCreateSxSStoreData(sxsId).extendedViewState?.attachmentId;
    const getAttachment = lazyGetAttachment.tryImportForRender();
    const attachmentModel = getAttachment?.(attachmentId);
    const fileType = getAttachmentFileType(attachmentModel);

    const itemId = getOrCreateSxSStoreData(sxsId).editState?.itemId?.Id;
    const message = (itemId && selectMailStoreItemById(itemId)) as Message;
    return {
        FileType: fileType,
        Sender: (message?.From || message?.Sender)?.Mailbox?.EmailAddress,
    };
};

export default getCustomPropertiesForSigs;
